import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FormTemplateNewPassword, ResetPasswordApproved } from "@tripian/react";
import Model from "@tripian/model";
import { api } from "@tripian/core";
import useTranslate from "../../hooks/useTranslate";
import { FORGOT_PASSWORD, LOGIN } from "../../constants/ROUTER_PATH_TITLE";

const NewPasswordPage = () => {
  const [success, setSuccess] = useState<boolean>(false);

  const { t } = useTranslate();

  const navigate = useNavigate();
  const { hash } = useParams<{ hash?: string }>();

  document.title = FORGOT_PASSWORD.TITLE(t("auth.forgotPassword.header"));

  const callbackSuccessLogin = (userResetPassword: Model.UserResetPassword) => {
    setSuccess(true);
  };

  if (!hash) {
    return (
      <div className="full-center">
        <p className="text-red-500">Invalid Link.</p>
      </div>
    );
  }

  return (
    <div className="full-center">
      {success ? (
        <ResetPasswordApproved goBackLogin={() => navigate(LOGIN.PATH)} t={t} />
      ) : (
        <FormTemplateNewPassword
          passwordCallBack={(password: string) =>
            api.userUpdatePassword(password, hash)
          }
          success={callbackSuccessLogin}
          t={t}
        />
      )}
    </div>
  );
};

export default NewPasswordPage;
